import { render } from "@testing-library/react";
import React, {Component, useState, useEffect} from "react";

class ConnectPopUp extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <React.Fragment>
                <div className="modal-widget">
                    <div className="modal-child">
                        <i className="fi fi-rr-cross" onClick={() => this.setState({showConnect: null})}></i>
                        <h3>Connect Wallet</h3>
                        <button>MetaMask</button>
                    </div>
                </div>
            </React.Fragment>
        )       
    }
}

export default ConnectPopUp;
